/* eslint-disable max-len */
export default function AttachAgendaItemFolderController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  oversightDataService,
  docDataService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Folder Added';
  vm.isExpanded = false;
  vm.loaded = false;
  vm.loading = false;

  // Attach Event Handlers
  vm.handleExpandFolder = _handleExpandFolder;
  vm.handleAttachFolder = _handleAttachFolder;

  function _handleExpandFolder() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshFolder();
    }
  }

  function _refreshFolder() {
    vm.loaded = false;
    loaderService.showViewLoader = true;

    docDataService.getChildItemList(vm.serviceId, vm.folder.documentId).then((response) => {
      vm.folder.childDocuments = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 0 });
      vm.folder.childFolders = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 1 });

      $q.all([
        _updateChildDocuments(),
        _updateChildFolders(),
      ]).then(() => {
        vm.loaded = true;
        loaderService.showViewLoader = false;
      });
    });
  }

  function _updateChildDocuments() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childDocuments.length > 0) {
      oversightDataService.getAgendaItemDocumentsByFolder(vm.folder.documentId).then((response) => {
        const assignedDocs = response.data.result;
        if (assignedDocs.length > 0) {
          assignedDocs.forEach((assignedDoc) => {
            vm.folder.childDocuments.forEach((childDoc) => {
              if (childDoc.documentId === assignedDoc.documentId && assignedDoc.agendaItemId === vm.agendaItemId) {
                childDoc.agendaItemDocumentId = assignedDoc.agendaItemDocumentId;
                childDoc.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _updateChildFolders() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childFolders.length > 0) {
      oversightDataService.getAgendaItemFoldersByFolder(vm.folder.documentId).then((response) => {
        const assignedFolders = response.data.result;
        if (assignedFolders.length > 0) {
          assignedFolders.forEach((assignedFolder) => {
            vm.folder.childFolders.forEach((childFolder) => {
              if (childFolder.documentId === assignedFolder.folderId && assignedFolder.agendaItemId === vm.agendaItemId) {
                childFolder.agendaItemFolderId = assignedFolder.agendaItemFolderId;
                childFolder.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _handleAttachFolder() {
    const dfdSave = $q.defer();

    if (vm.folder.attached) {
      oversightDataService.attachAgendaItemFolder(vm.agendaItemId, vm.folder.documentId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while attaching the Folder.');
          dfdSave.reject();
        } else {
          alerts.success(`Folder ${vm.folder.name} has been attached successfully.`);
          vm.folder.agendaItemFolderId = response.data.agendaItemFolderId;
          $rootScope.$broadcast('refreshAgendaItemFolders', { agendaItemId: vm.agendaItemId });
          $rootScope.$broadcast('refreshAgendaItemDocuments', { agendaItemId: vm.agendaItemId });
          $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
          dfdSave.resolve();
        }
      });
    } else {
      oversightDataService.detachAgendaItemFolder(vm.folder.agendaItemFolderId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while detaching the Folder.');
          dfdSave.reject();
        } else {
          alerts.success(`Folder ${vm.folder.name} has been detached successfully.`);
          vm.folder.agendaItemFolderId = null;
          $rootScope.$broadcast('refreshAgendaItemFolders', { agendaItemId: vm.agendaItemId });
          $rootScope.$broadcast('refreshAgendaItemDocuments', { agendaItemId: vm.agendaItemId });
          $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
          dfdSave.resolve();
        }
      });
    }
  }
}

AttachAgendaItemFolderController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'oversightDataService',
  'docDataService'
];
